import React from 'react';
import {
  IconPaint, IconAiPencil, IconCopyFile, IconAiImage, IconAiText, IconAiSelection,
  Link,
} from 'gatorcomponents';

export default {
  tag: {
    label: 'Pro',
    youArePro: 'Você é PRO',
  },
  studioTitle: {
    pro: 'HostGator Studio Pro',
    free: 'HostGator Studio',
  },
  logoBuilder: 'Criador de logos',
  modalInitialQuestions: {
    title: 'Vamos personalizar o Studio Grátis com base nas suas preferências.',
    titlePro: 'Vamos personalizar o Studio Pro com base nas suas preferências.',
    buttonContinue: 'Continuar',
    buttonBack: 'Voltar',
    labelQuestion1: 'O que você deseja criar com o Studio?',
    labelQuestion2: 'Qual a área do seu negócio ou projeto?',
    labelQuestion3: 'Você já utilizou outras plataformas de design?',
    question1: {
      logo: 'Logo e elementos de identidade visual',
      socialMedia: 'Conteúdo para redes sociais (Instagram, Facebook, etc...)',
      marketing: 'Materiais para marketing e vendas',
      ecommerce: 'Elementos e conteúdo para loja virtual',
      graphic: 'Materiais para impressão',
      others: 'Outros',
    },
    question3: {
      yes: 'Sim',
      no: 'É a primeira vez',
    },
    errorDescription: (
      <>
        Ocorreu um erro ao continuar.
        <br />
        {' '}
        Caso persista, tente novamente mais tarde.
      </>
    ),
    buttonError: 'Ok, entendi',
  },
  bussinessCategories: {
    accounting: 'Contabilidade',
    architecture: 'Arquitetura',
    artificialIntelligence: 'Inteligência Artificial',
    bakeries: 'Padarias',
    carRentals: 'Locadoras de Veículos',
    clinicsAndPractices: 'Clínicas e Consultórios',
    clothingAndAccessories: 'Roupas e Acessórios',
    clothingStores: 'Lojas de Roupas',
    constructionAndRealEstate: 'Construção e Imobiliário',
    corporateTraining: 'Treinamentos Corporativos',
    educationAndTraining: 'Educação e Treinamento',
    ecotourism: 'Ecoturismo',
    electronics: 'Eletrônicos',
    entertainmentAndArts: 'Entretenimento e Artes',
    eventsAndConcerts: 'Eventos e Shows',
    fashionAndClothing: 'Moda e Vestuário',
    financeAndLegal: 'Finanças e Jurídico',
    fintechs: 'Fintechs',
    fitness: 'Fitness',
    foodAndBeverage: 'Alimentação e Bebidas',
    foodDelivery: 'Entrega de Comida',
    footwear: 'Calçados',
    gamesAndApps: 'Jogos e Aplicativos',
    groupsMusicals: 'Grupos Musicais',
    healthAndWellbeing: 'Saúde e Bem-estar',
    hotelsAndInns: 'Hotéis e Pousadas',
    interiorDesignAndDecoration: 'Decoração e Design de Interiores',
    investments: 'Investimentos',
    jewelryAndWatches: 'Joias e Relógios',
    languages: 'Idiomas',
    lawFirms: 'Escritórios de Advocacia',
    landscaping: 'Paisagismo',
    luxuryBrands: 'Marcas de Luxo',
    marketingAndCommunication: 'Marketing e Comunicação',
    mentalHealth: 'Saúde Mental',
    deliveryService: 'Serviço de entrega',
    naturalProducts: 'Produtos Naturais',
    onlineCourses: 'Cursos Online',
    pastriesAndBakeries: 'Docerias e Padarias',
    petStores: 'Lojas de animais',
    photographyStudios: 'Estúdios de Fotografia',
    publicRelations: 'Relações Públicas',
    realEstate: 'Imobiliárias',
    resorts: 'Resorts',
    restaurantsAndCafes: 'Restaurantes e Cafeterias',
    retailAndCommerce: 'Varejo e Comércio',
    schoolsAndUniversities: 'Escolas e Universidades',
    softwareDevelopment: 'Desenvolvimento de Software',
    startups: 'Startups',
    supermarkets: 'Supermercados',
    sustainableFashion: 'Moda Sustentável',
    technologyAndInnovation: 'Tecnologia e Inovação',
    transportAndLogistics: 'Transporte e Logística',
    transporters: 'Transportadoras',
    tourismAndHospitality: 'Turismo e Hotelaria',
    videoProduction: 'Produção de Vídeos',
    others: 'Outros',
  },
  topBanner: {
    free: 'HostGator Studio',
    pro: 'HostGator Studio Pro',
    title: (
      <>
        Crie designs incríveis para sua marca
        <br />
        {' '}
        com o poder da Inteligência Artificial
      </>
    ),
    ButtonLabel: 'Experimente o Pro',
    credits: ' créditos',
    forYou: 'Para você',
    design: 'Design',
    projects: 'Projetos',
    createAiSite: 'Crie site com IA',
    alertTitle: days => `Lembrete: Faltam ${days} dias para o seu teste acabar.`,
    alertDescription: price => (
      <>
        Continue utilizando todos os benefícios do Pro. Vamos debitar nos próximos dias o valor de
        {' '}
        <span className="text-price">{price}</span>
        {' '}
        no cartão cadastrado.
      </>
    ),
    creditAnalysis: {
      yourPlan: 'Seu plano',
      creditsUsedPercentage: percentage => `Você usou ${percentage}% dos seus créditos`,
      creditsHasEndedUpgrade: 'Seus créditos esgotaram. Melhore seu plano para utilizar os recursos do Studio Pro, ou aguarde até a renovação.',
      creditsHasEnded: 'Seus créditos esgotaram. Aguarde até a renovação no próximo mês.',
      creditsUsed: quantity => (
        <>
          <strong>{quantity}</strong>
          {' Créditos utilizados'}
        </>
      ),
      creditsAvailable: quantity => (
        <>
          {'Créditos disponíveis '}
          <strong>{quantity}</strong>
        </>
      ),
      nextRecharge: dateString => (
        <>
          {'Próxima recarga de créditos em '}
          <strong>
            {dateString}
          </strong>
        </>
      ),
      upgradePlan: 'Melhore o seu plano e ganhe créditos extras para continuar criando.',
      goToProButtonLabel: 'Ir para o Pro',
      learnMore: (
        <>
          {'Créditos são utilizados para criar designs com IA. '}
          <Link
            text="Saiba mais."
            href="https://suporte.hostgator.com.br/hc/pt-br/articles/40042184564371-Como-funcionam-os-cr%C3%A9ditos-na-HG-Studio"
            target="_blank"
          />
        </>
      ),
    },
    alertTitleNoCard: 'Seu período de teste está acabando',
    alertDescriptionNoCard: 'Não fique sem os recursos do Pro, adquira agora mesmo e continue utilizando os benefícios.',
    ctaNoCard: 'Ativar o Pro',
  },
  highlightFeatures: {
    tag: {
      label: 'Pro',
    },
    header: {
      titleFeatures: 'Domine a arte de criar com o Pro',
      labelButtonAi: 'Crie site com IA',
    },
    logoBuilder: {
      title: 'Criador de logo com IA',
      description: 'Crie logos profissionais para a sua marca.',
    },
    scaleDesign: {
      title: 'Design em escala',
      description: 'Acelere seu processo criativo em alta escala.',
    },
    backgroundRemover: {
      title: 'Remover fundo com IA',
      description: 'Remova fundos em segundos',
    },
    brandKit: {
      title: 'Kit de marca',
      description: 'Sua identidade visual forte todos os canais',
    },
  },
  modalFeaturePro: {
    title: {
      BACKGROUND_REMOVER: (
        <>
          Remova o fundo das suas imagens
          <br />
          com a praticidade da IA
        </>
      ),
      BRAND_KIT: (
        <>
          Crie seu kit de marca com o
          <br />
          poder da IA
        </>
      ),
      LOGO_BUILDER: (
        <>
          Crie logo profissionais com o
          <br />
          poder da IA
        </>
      ),
      SCALE_DESIGN: (
        <>
          Crie design em escala com o
          <br />
          poder da IA
        </>
      ),
      NO_CREDITS: (
        <>
          Você atingiu o limite de créditos para
          <br />
          usar os recursos com IA.
        </>
      ),
      STUDIO_PRO: (
        <>
          Seja Pro e tenha acesso a todos os
          <br />
          recursos do Studio.
        </>
      ),
      STUDIO_PRO_TRIAL: (
        <>
          Teste o plano Pro por
          {' '}
          <strong>7 dias</strong>
          {' '}
          e tenha acesso a todos os recursos.
        </>
      ),
      STUDIO_PRO_OFFER: 'Seja Pro e crie designs criativos',
    },
    textStudioPro: planPrice => `Aproveite o Pro por ${planPrice} / mês`,
    textStudioProTrial: 'Teste o plano e tenha resultados profissionais',
    textStudioFree: planPrice => `Experimente o Pro por ${planPrice} / mês`,
    textStudioTrial: (
      <>
        Experimente o Studio Pro por
        {' '}
        <strong>7 dias grátis</strong>
        {' '}
        sem precisar de cartão de crédito
      </>
    ),
    listFeaturesPro: {
      brandKit: {
        text: 'Kit de marca para criar designs consistentes usando as cores e padrões da sua marca.',
        icon: <IconPaint color="primaryBlue" size="md" />,
      },
      logoBuilder: {
        text: 'Criador de logo com IA',
        icon: <IconAiPencil color="primaryBlue" size="md" />,
      },
      templates: {
        text: 'Milhares de templates para começar',
        icon: <IconCopyFile color="primaryBlue" size="md" />,
      },
      scaleDesign: {
        text: 'Crie centenas de designs em escala com IA',
        icon: <IconAiImage color="primaryBlue" size="md" />,
      },
      filterFontsTemplates: {
        text: 'Filtros, fontes e templates premium',
        icon: <IconAiText color="primaryBlue" size="md" />,
      },
      advancedFeatures: {
        text: 'Recursos avançados no editor',
        icon: <IconAiSelection color="primaryBlue" size="md" />,
      },
    },
    buttonGoPlansLabel: 'Ver detalhes do plano',
    buttonFreeLabel: 'Seja Pro',
    buttonTrialLabel: 'Teste grátis',
    buttonOfferTrialLabel: 'Ativar 7 dias grátis',
    buttonOkLabel: 'Ok, entendi',
    buttonNotNowLabel: 'Agora não',
    textCancellation: 'Cancele a qualquer momento.',
    titleNoCredits: 'Você atingiu o limite de créditos para usar os recursos com IA.',
    textNoCredits: 'Seus créditos serão recarregados dia %date%',
    textNoCreditsFree: 'Seus créditos serão recarregados dia %date%. Seja Pro e renove os créditos agora mesmo.',

    purchaseTrial: {
      title: 'Crie com o Pro grátis',
      description: (discount = 30) => (
        <>
          {'Ganhe mais pagando menos!  Assine agora com cartão de crédito e ganhe '}
          <strong>{`${discount}% de desconto.`}</strong>
        </>
      ),
      options: {
        creditCard: {
          title: 'Teste com cartão de crédito',
          discount: value => (
            <>
              {'Desconto de '}
              <strong>{`${value}% off`}</strong>
            </>
          ),
          price: value => (
            <strong>
              {'Valor: '}
              {value}
              {' / mês'}
            </strong>
          ),
          bottomText: 'Cancele quando quiser',
        },
        noCreditCard: {
          title: 'Teste sem o cartão de crédito',
          description: 'Teste por 7 dias de graça, sem cobrança.',
          price: value => (
            <>
              <strong>{`Valor: ${value} / `}</strong>
              mês após o teste
            </>
          ),
        },
      },
      cancelButtonLabel: 'Cancelar',
      continueButtonLabel: 'Continuar',
      bottomMessage: (
        <>
          {'Ao continuar, você concorda com os '}
          <Link text="Termos de Uso" href="https://suporte.hostgator.com.br/hc/pt-br/articles/39904180477331-Termos-de-uso-do-HostGator-Studio" />
          {' aplicáveis ao Studio Pro e confirma que leu nossa '}
          <Link text="Política de Privacidade." href="https://www.newfold.com/privacy-center/privacy" />
        </>
      ),

      howTestWorks: 'Como o teste funciona',
      timeline: {
        startOfTest: {
          title: (
            <>
              <strong>{'Hoje '}</strong>
              {' Início do teste'}
            </>
          ),
          description: 'Acesso a todas as funcionalidades do plano Pro, incluindo designs com IA.',
        },
        reminderOfTest: {
          title: (
            <>
              <strong>{'Em 5 dias '}</strong>
              {' Lembrete'}
            </>
          ),
          description: 'Te avisaremos quando o fim do teste estiver se aproximando.',
        },
        endOfTest: {
          title: (
            <>
              <strong>{'Após 7 dias '}</strong>
              {' Início da assinatura'}
            </>
          ),
          description: value => (
            <>
              {'O plano pro será cobrado apenas '}
              <strong>
                para quem escolheu testar com cartão de crédito
              </strong>
              {` no valor de ${value}`}
            </>
          ),
        },
        bottomText: 'Cancele quando quiser. Vamos te lembrar antes do fim do período de teste.',
      },
    },
  },
  modalLogoGeneration: {
    createYourLogoInSeconds: 'Crie sua logo em segundos',
    tellUsAboutYourBrand: 'Conte um pouco sobre a sua marca',
    brandName: 'Qual o nome da sua marca?',
    brandSlogan: 'Qual o slogan da sua marca?',
    category: 'Selecione a categoria da empresa',
    categories: [
      'Alimentação e Bebidas',
      'Arquitetura',
      'Calçados',
      'Clínicas e Consultórios',
      'Construção e Imobiliário',
      'Contabilidade',
      'Cursos Online',
      'Decoração e Design de Interiores',
      'Desenvolvimento de Software',
      'Docerias e Padarias',
      'Ecoturismo',
      'Educação e Treinamento',
      'Eletrônicos',
      'Engenharia Civil',
      'Entrega de Comida',
      'Entretenimento e Artes',
      'Escolas e Universidades',
      'Escritórios de Advocacia',
      'Estética e Beleza',
      'Estúdios de Fotografia',
      'Eventos e Shows',
      'Finanças e Jurídico',
      'Fintechs',
      'Fitness',
      'Grupos Musicais',
      'Hotéis e Pousadas',
      'Idiomas',
      'Imobiliárias',
      'Inteligência Artificial',
      'Investimentos',
      'Jogos e Aplicativos',
      'Joias e Relógios',
      'Locadoras de Veículos',
      'Lojas de Roupas',
      'Marcas de Luxo',
      'Marketing e Comunicação',
      'Moda e Vestuário',
      'Moda Sustentável',
      'Padarias',
      'Paisagismo',
      'Pet Shop',
      'Produção de Vídeos',
      'Produtos Naturais',
      'Relações Públicas',
      'Resorts',
      'Restaurantes e Cafeterias',
      'Roupas e Acessórios',
      'Saúde e Bem-estar',
      'Saúde Mental',
      'Serviço de entrega',
      'Supermercados',
      'Tecnologia e Inovação',
      'Transporte',
      'Treinamentos Corporativos',
      'Turismo e Hotelaria',
      'Varejo e Comércio',
    ],
    selectColor: 'Selecione a cor que melhor represente a sua marca',
    selectCustomColor: 'Cor secundária (Opcional)',
    colors: [
      {
        name: 'Preto',
        background: '#000000',
      },
      {
        name: 'Azul',
        background: '#3897F0',
      },
      {
        name: 'Roxo',
        background: '#785CFF',
      },
      {
        name: 'Verde',
        background: '#2EB67D',
      },
      {
        name: 'Rosa',
        background: '#FF35AE',
      },
      {
        name: 'Amarelo',
        background: '#F4DD08',
      },
      {
        name: 'Laranja',
        background: '#FF9900',
      },
      {
        name: 'Vermelho',
        background: '#FF4B56',
      },
    ],
    buttonBackLabel: 'Voltar',
    buttonCreateLabel: 'Criar logo',
    errorMessage: 'Selecione uma cor e preencha os itens obrigatórios antes de continuar',
    helpTextSlogan: 'Uma frase que define sua marca.',
    generatingLogo: 'Estamos solicitando o seu logo profissional, um momento...',
    noCredits: 'Seus créditos acabaram e serão renovados automaticamente em 21/02/2025.',
    noCreditsForLogoBuilder: 'Seus créditos não são suficientes para gerar mais logos. Para continuar, crie manualmente.',
    buttonGoStudio: {
      labelFree: 'Ir para o Studio Grátis',
      labelPro: 'Ir para o Studio Pro',
    },
    buttonRetryLabel: 'Gerar mais opções',
    textRetry: 'Você pode gerar mais um logotipo com seus créditos atuais.',
    buttonCreateLogoManuallyLabel: 'Criar logo manualmente',
    buttonGoProLabel: 'Seja pro',
    titleCreatingLogos: 'Criando seus logos, um momento...',
    titleLogosCreated: 'Criamos %number% variações de logotipo para você',
    titleError: (
      <>
        Ocorreu um erro ao gerar sua logo
        <br />
        Caso persista, tente novamente mais tarde.
      </>
    ),
    buttonErrorLabel: 'Tentar novamente',
  },
  bannerOfferPro: {
    title: 'Seja Pro',
    description: 'Tenha acesso a uma experiência premium na criação das suas artes, com templates selecionados e alto potencial de conversão.',
    buttonLabel: 'Experimente o Pro',
  },
  buttonCreateSiteAi: {
    label: 'Criar site com IA',
  },
  headerDesignSection: {
    headerText: 'Escolha modelos para sua criação',
    tooltip: 'Criar novo projeto',
  },
  templateList: {
    seeMore: 'Mostrar mais',
    showMoreTemplates: 'Mostrar mais templates',
    formats: {
      instagram_post: 'Post para Instagram',
      insta_stories: 'Stories para Instagram',
      global_facebook_post: 'Post para Facebook',
      global_facebook_vertical: 'Stories para Facebook',
      global_facebook_capa: 'Capa para Facebook',
      global_capa_youtube: 'Capa para Youtube',
      global_youtube_icone: 'Ícone do Youtube',
      global_whatsapp_post: 'Post para whatsapp',
      capa_tiktok: 'TikTok',
      catalogo_virtual: 'Catálogo',
      global_ebook_A4_Vertical: 'E-book',
      mini_sites: 'Mini site',
      promo_link: 'Promoções',
    },
    altText: 'foto do template',
  },
  modalPlanHireSuccess: {
    title: 'Parabéns, agora você faz parte do Studio Pro!',
    description: 'Aproveite todos os recursos avançados com IA e comece a criar',
    buttonLabel: 'Começar a criar',
    animationAlt: 'animação de confete',
    successAlt: 'imagens diversas',
  },
};
